import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { MedicareBasedConfigSection } from '../../sections';

const MedicareBasedConfigTab: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        Medicare Based Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Configure Medicare-based settings and rules that determine how this contract relates to Medicare rates and calculations.
      </Typography>

      <Stack spacing={3}>
        <MedicareBasedConfigSection />
      </Stack>
    </Box>
  );
};

export default MedicareBasedConfigTab;